import { Reveal, Eyebrow } from "@/components/Reveal";

const SAMPLES = [
  ["/images/p1.jpg", "Sample project: Local service business website", "Concept 5-page mobile-friendly website with services, gallery, Google Maps and WhatsApp button.", "Laptop showing a sample business website design"],
  ["/images/p2.jpg", "Sample project: Retail shop website & digital card", "Concept product showcase site with a shareable digital business card and contact form.", "Laptop on a desk showing a sample shop website layout"],
  ["/images/p3.jpg", "Sample project: Consultant site with online booking", "Concept website with an appointment booking flow and basic chatbot for common questions.", "Laptop showing a sample consultant website with booking"],
];

export const Portfolio = () => (
  <section id="portfolio" className="relative py-24 sm:py-32" data-testid="portfolio-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow index="06">Portfolio</Eyebrow>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-6xl">Sample projects</h2>
        <p className="mt-4 max-w-2xl text-sm text-slate-300 sm:text-base">These are sample concept projects that show the type of work we offer. Real client projects will be added here as they are completed.</p>
      </Reveal>
      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {SAMPLES.map(([src, title, desc, alt], i) => (
          <Reveal key={title} delay={i * 0.08}>
            <article className="group h-full overflow-hidden rounded-3xl border border-white/10 bg-[#0E1526]" data-testid={`portfolio-item-${i + 1}`}>
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <span className="absolute left-4 top-4 rounded-full bg-[#070B14]/85 px-3 py-1 font-mono text-[11px] uppercase tracking-wider text-amber-200">Sample project</span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-lg font-bold text-white">{title}</h3>
                <p className="mt-2 text-sm text-slate-300">{desc}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
